<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.07238 2.66666L1.33325 6.03508L7.99992 13.3333L14.6666 6.03508L12.9275 2.66666H3.07238Z"
      stroke="#ECFDF5"
      stroke-width="1.5"
      stroke-linecap="square"
    ></path>
    <path
      d="M1.66675 6H14.3334"
      stroke="#ECFDF5"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round"
    ></path>
    <path
      d="M5.5293 6L7.99988 2.66666L10.4705 6"
      stroke="#ECFDF5"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round"
    ></path>
    <path
      d="M5.33325 6L7.99992 13.3333L10.6666 6"
      stroke="#ECFDF5"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
